export function copy(object){
  if(!object){
    return object
  }

  return JSON.parse(JSON.stringify(object))
}
